<template>
  <div>
    <!-- UI-11: Agent dashboard widgets -->
    <b-card-group deck class="mb-3">
      <b-card :style="{ backgroundColor: 'var(--bg-card)', color: 'var(--text-foreground)' }">
        <b-row align-v="center">
          <b-col>
            <p class="h1 text-center"><b-icon icon="pc-display"/></p>
          </b-col>
          <b-col>
            <b-card-title class="text-right">{{ totalAgents }} Агенты</b-card-title>
            <b-card-text class="text-right">
              <b-badge variant="success" class="mr-1">{{ onlineAgents }} в сети</b-badge>
              <b-badge variant="danger">{{ offlineAgents }} не в сети</b-badge>
            </b-card-text>
          </b-col>
        </b-row>
      </b-card>
      <b-card :style="{ backgroundColor: 'var(--bg-card)', color: 'var(--text-foreground)' }">
        <b-row align-v="center">
          <b-col>
            <p class="h1 text-center"><b-icon icon="collection-play-fill"/></p>
          </b-col>
          <b-col>
            <b-card-title class="text-right">{{ totalTasks }} Задачи</b-card-title>
            <b-card-text class="text-right">
              <b-badge variant="warning" class="mr-1">{{ runningTasks }} Выполняются</b-badge>
              <b-badge variant="success">{{ completedTasks }} Готовы</b-badge>
            </b-card-text>
          </b-col>
        </b-row>
      </b-card>
      <b-card :style="{ backgroundColor: 'var(--bg-card)', color: 'var(--text-foreground)' }">
        <b-row align-v="center">
          <b-col>
            <p class="h1 text-center"><b-icon icon="hdd-network"/></p>
          </b-col>
          <b-col>
            <b-card-title class="text-right">{{ totalSites }} Сайты</b-card-title>
            <b-card-text class="text-right">{{ totalAgents }} агентов распределено</b-card-text>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>

    <!-- Tasks by agent -->
    <b-card :style="{ backgroundColor: 'var(--bg-card)', color: 'var(--text-foreground)' }" class="mb-3" v-if="agentStats.length > 0">
      <template #header>
        <h5 class="mb-0" style="color: var(--text-foreground);">Задачи по агентам</h5>
      </template>
      <div v-for="agent in agentStats" :key="agent.id" class="mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>
            <span :class="['status-dot', agent.status === 'online' ? 'online' : 'offline']" class="mr-2"></span>
            <strong>{{ agent.name }}</strong>
            <small style="color: var(--text-muted);" class="ml-2">{{ agent.hostname || '' }}</small>
          </span>
          <span style="color: var(--text-muted);">{{ agent.task_count }} задач</span>
        </div>
        <b-progress :max="maxTaskCount" height="6px" class="mt-1">
          <b-progress-bar :variant="agent.status === 'online' ? 'success' : 'secondary'" :value="agent.task_count"></b-progress-bar>
        </b-progress>
      </div>
    </b-card>

    <!-- Empty state -->
    <empty-state
      v-if="totalAgents === 0"
      icon="pc-display"
      title="Нет агентов"
      description="Установите агенты для распределённого сканирования"
    />
  </div>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'agentDashboard',
  mixins: [RekonoApi],
  data () {
    this.fetchAgents()
    this.fetchSites()
    this.fetchTasks()
    return {
      totalAgents: 0,
      onlineAgents: 0,
      offlineAgents: 0,
      totalSites: 0,
      totalTasks: 0,
      runningTasks: 0,
      completedTasks: 0,
      agentStats: [],
      maxTaskCount: 1
    }
  },
  methods: {
    fetchAgents () {
      this.get('/api/agents/', 1, 100).then(response => {
        this.totalAgents = response.data.count
        this.onlineAgents = response.data.results.filter(a => a.status === 'online').length
        this.offlineAgents = this.totalAgents - this.onlineAgents
        this.agentStats = response.data.results.map(a => ({
          ...a,
          task_count: 0
        }))
        this.fetchAgentTasks()
      })
    },
    fetchAgentTasks () {
      this.agentStats.forEach((agent, i) => {
        this.get('/api/tasks/', 1, 1, { agent: agent.id }).then(response => {
          this.agentStats[i].task_count = response.data.count
          this.maxTaskCount = Math.max(this.maxTaskCount, response.data.count)
          // Force reactivity
          this.agentStats = [...this.agentStats]
        })
      })
    },
    fetchSites () {
      this.get('/api/sites/', 1, 100).then(response => {
        this.totalSites = response.data.count
      })
    },
    fetchTasks () {
      this.get('/api/tasks/', 1, 1, { status: 'Running' }).then(response => {
        this.runningTasks = response.data.count
      })
      this.get('/api/tasks/', 1, 1, { status: 'Completed' }).then(response => {
        this.completedTasks = response.data.count
      })
      this.get('/api/tasks/', 1, 1).then(response => {
        this.totalTasks = response.data.count
      })
    }
  }
}
</script>

<style scoped>
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.status-dot.online {
  background-color: #22C55E;
  box-shadow: 0 0 4px #22C55E;
}
.status-dot.offline {
  background-color: #ef4444;
}
</style>